import { rotateDocumentPageMutation } from './graphql';

export const rotateImage = (documentId, pageIndex, rotateDirection) => {
  return async (dispatch, getState, { client }) => {
    await rotateDocumentPageMutation(client, documentId, pageIndex, rotateDirection);
  };
};

export const rotateClockwise = (documentId, pageIndex) => {
  return rotateImage(documentId, pageIndex, 'clockwise');
};
